export default __webpack_public_path__ + "static/media/misc-closetC-1440w.8c197975.avif";